import { Crown, RotateCcw, X } from "lucide-react";

/**
 * Per-row action buttons on the admin waitlist CRM.
 *
 * Renders the correct button set for the row's current status:
 * - `new`: [Mark Founder] [Archive]
 * - `founder`: Terms-signed indicator OR [Mark terms signed]; [Undo]
 * - `archived`: [Undo]
 *
 * The parent owns the API calls (they need to touch its optimistic row
 * state), so this component just delegates via `onSetStatus(next)` /
 * `onMarkTermsSigned()`. `busy` disables buttons during a pending PATCH so
 * a fast double-click doesn't fire two writes.
 */
export function RowActions({ row, busy, onSetStatus, onMarkTermsSigned }) {
  const status = row.status || "new";
  const isFounder = status === "founder";
  const isArchived = status === "archived";

  return (
    <div className="flex flex-wrap items-center gap-1.5">
      {status === "new" && (
        <>
          <button
            type="button"
            data-testid={`admin-mark-founder-${row.email}`}
            disabled={busy}
            onClick={() => onSetStatus("founder")}
            className="inline-flex items-center gap-1 rounded-full border border-gold/60 bg-gold/10 px-3 py-1 text-[0.7rem] font-medium text-[#8B6F1F] hover:border-transparent hover:bg-gold hover:text-black disabled:opacity-60"
          >
            <Crown className="h-3 w-3" />
            Mark Founder
          </button>
          <button
            type="button"
            data-testid={`admin-archive-${row.email}`}
            disabled={busy}
            onClick={() => onSetStatus("archived")}
            className="inline-flex items-center gap-1 rounded-full border border-black/10 px-3 py-1 text-[0.7rem] text-[#6B6B6B] hover:border-black/30 hover:text-[#2A2724] disabled:opacity-60"
          >
            <X className="h-3 w-3" />
            Archive
          </button>
        </>
      )}
      {(isFounder || isArchived) && (
        <>
          {isFounder &&
            (row.terms_signed_at ? (
              <span
                data-testid={`admin-terms-signed-${row.email}`}
                className="inline-flex items-center gap-1 rounded-full border border-gold/60 bg-gold/10 px-3 py-1 text-[0.7rem] font-medium text-[#8B6F1F]"
              >
                <Crown className="h-3 w-3" />
                Terms signed
              </span>
            ) : (
              <button
                type="button"
                data-testid={`admin-mark-terms-signed-${row.email}`}
                disabled={busy}
                onClick={onMarkTermsSigned}
                className="inline-flex items-center gap-1 rounded-full border border-gold/60 px-3 py-1 text-[0.7rem] font-medium text-[#8B6F1F] hover:border-transparent hover:bg-gold hover:text-black disabled:opacity-60"
              >
                Mark terms signed
              </button>
            ))}
          <button
            type="button"
            data-testid={`admin-restore-${row.email}`}
            disabled={busy}
            onClick={() => onSetStatus("new")}
            className="inline-flex items-center gap-1 rounded-full border border-black/10 px-3 py-1 text-[0.7rem] text-[#6B6B6B] hover:border-black/30 hover:text-[#2A2724] disabled:opacity-60"
          >
            <RotateCcw className="h-3 w-3" />
            Undo
          </button>
        </>
      )}
    </div>
  );
}
